import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaSearch } from 'react-icons/fa';
import './backorder.scss';
import Filter from 'ui-component/filter-menu/Filter';
import Scroller from 'ui-component/Scroller';
import Pagination from 'ui-component/Pagination';
import usePageTitle from 'hooks/usePageTitle';
import { ReadyIcon, EstimateIcon } from 'ui-component/custom-icons/icons';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import { Skeleton } from '@mui/material';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';

import { storeSearchBackOrder, storeActiveBackOrderTab } from 'store/reducers/mainSlice';
import useIsMobile from 'utils/isMobileUtils';

const Backorders = () => {
	const [setPageTitle] = usePageTitle('Backorders');
	const history = useNavigate();
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);
    const dispatch = useDispatch();

	const storedSearch = useSelector((state) => state.main.searchBackOrder);
	const storedFilter = useSelector((state) => state.main.filterBackOrder);
	const activeBackOrdertab = useSelector((state) => state.main.activeBackOrderTab);

	const [activeComponent, setActiveComponent] = useState('order');
	const [filters, setFilters] = useState([]);
	const [searchField, setSearchField] = useState();
	const [activeFilters, setActiveFilters] = useState({});
	const [pagination, setpagination] = useState(null);
	const [searchTimeout, setSearchTimeout] = useState(null);
	
	const [data, setData] = useState(null);
	
	const [isLoading, setIsLoading] = useState(true);
	
	const handleComponentChange = (component) => {
		setIsLoading(true)
		setActiveComponent(component);
		setSearchField('');
        dispatch(storeActiveBackOrderTab(component));
        dispatch(storeSearchBackOrder(''));
		// setActiveFilters({});
	};
	const handleData = (data) => {
		setData(data?.data);
		setpagination(data);
	};


    useEffect(() => {

        const fetchData = async () => {
            if (storedSearch) {
                setIsLoading(true);
                await handleSearch({ target: { value: storedSearch } });
            } else if (!storedSearch) {
                if (storedFilter && Object.keys(storedFilter).length > 0) {
                    setIsLoading(true);
                    await handleFilterRedux();
                } else {
                    handleFilter()
                }
            }
        };
		fetchData();
		
		if (activeBackOrdertab) {
			setActiveComponent(activeBackOrdertab)
		} else {
			setActiveComponent('order')
		}
    }, [storedSearch, searchField, activeFilters, storedFilter, activeBackOrdertab]);

	const getBackOrderLists = async () => {
		const storedActiveTab = activeBackOrdertab || 'order';
		api.getbackorders(storedActiveTab).then((res) => {
			setIsLoading(false)
			setData(res?.data?.data);
			setpagination(res?.data);
		});
	}


    useEffect(() => {
        getFiltersList();
    }, []);

    const getFiltersList = () => {
        api.getBackOrderFilter().then((res) => {
            setFilters(res.data);
        });
    };


    const handleSearch = (e) => {
        let text = e.target.value;
        setSearchField(text);

        dispatch(storeSearchBackOrder(text));
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        let timeout = setTimeout(() => {
            setIsLoading(true);
            if (text.length > 2) {
                api.filterBackOrders(activeComponent, activeFilters, text).then((res) => {
                    setIsLoading(false);
                    setData(res.data.data);
                    setpagination(res.data);
                });
            } else if (text.length > 0 && text.length <= 2) {
                setIsLoading(false);
            } else {
                api.filterBackOrders(activeComponent, activeFilters, null).then((res) => {
                    setIsLoading(false);
                    setData(res.data.data);
                    setpagination(res.data);
                });
            }
        }, 1000);

        setSearchTimeout(timeout);
    };


    const handleFilter = (activeF = null, searchF = null) => {
        setIsLoading(true);
        api.filterBackOrders(activeComponent, activeFilters, searchField?.length > 2 ? searchField : null).then((res) => {
            setIsLoading(false);
            setData(res.data.data);
            setpagination(res.data);
        });
    };

    const handleFilterRedux = (activeF = null, searchF = null) => {
        setIsLoading(true);
        api.filterBackOrders(activeComponent, storedFilter, searchField?.length > 2 ? searchField : null).then((res) => {
            setIsLoading(false);
            setData(res.data.data);
            setpagination(res.data);
        });
    };

	const isMobile = useIsMobile();
	

	return (
		<div className="row">
			<div className="col-xl-12 col-lg-12">
				<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
					<div className="header-bubble" />
					<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
						<div
							style={{
								position: 'relative',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								marginBottom: 8,
								minHeight: 38 // ensures enough height for the button
							}}
						>
							<h5 style={{ textAlign: 'center', flex: 1, margin: 0 }}>Backorders</h5>
						</div>
						<div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 10 }}>
							<button
								className="btn btn-main"
								style={{ width: 100 }}
								onClick={() => {
									handleComponentChange('order');
								}}
							>
								Per Order
							</button>
							<button
								className="btn btn-main"
								style={{ width: 100 }}
								onClick={() => {
									handleComponentChange('product');
								}}
							>
								Per Product
							</button>
						</div>
					</div>
				</div>
				<div className="section-head-new hide-on-mobile" style={{ margin: '10px 0px' }}>
					<ul className="topListCom">
						<li
							className={`${activeComponent === 'order' ? 'active' : ''}`}
							onClick={() => {
								handleComponentChange('order');
							}}
						>
							<span className="topListIcon">
								<EstimateIcon width={14} height={14} />
							</span>
							<span className="topListText">Per order </span>
						</li>
						<li
							className={`${activeComponent === 'product' ? 'active' : ''}`}
							onClick={() => {
								handleComponentChange('product');
							}}
						>
							<span className="topListIcon">
								<ReadyIcon width={14} height={14} />
							</span>
							<span className="topListText">Per product </span>
						</li>
					</ul>
					<div className="actions"></div>
				</div>

				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						gap: 10,
						paddingTop: 0,
						paddingBottom: 5,
						paddingLeft: 20,
						paddingRight: 20
					}}
					className="show-on-mobile"
				>
					<form className="form-inline navbar-search" style={{ flex: 1 }}>
						<div style={{ position: 'relative', width: '100%' }}>
							<input
								type="text"
								className="form-control bg-white border"
								placeholder="Search"
								aria-label="Search"
								aria-describedby="basic-addon2"
								value={searchField}
								onChange={handleSearch}
								style={{ width: '100%', paddingRight: 36 }}
							/>
							<span
								className="searchIcon"
								style={{
									position: 'absolute',
									right: 10,
									top: '50%',
									transform: 'translateY(-50%)',
									color: '#888',
									pointerEvents: 'none'
								}}
							>
								<FaSearch />
							</span>
						</div>
					</form>
					<div style={{ flexShrink: 0 }}>
						<Filter activeFilters={activeFilters} onSubmit={setActiveFilters} filters={filters} multi={undefined} source={'picklist'} />
					</div>
				</div>

				<div className={`card shadow-sm  bg-white mb-4  table-card ${isMobile ? 'shorter-table' : ''}`}>
					<div className=" align-items-center justify-content-between TableSerachBar">
						<div>
							<Filter activeFilters={activeFilters} onSubmit={setActiveFilters} filters={filters} source={'backorder'} />
						</div>
						<form className="form-inline navbar-search" style={{ display: 'flex', gap: '5px' }} onSubmit={(e) => e.preventDefault()}>
							<div className="input-group">
								<input
									type="text"
									className="form-control bg-white border"
									placeholder="Search"
									aria-label="Search"
									aria-describedby="basic-addon2"
									value={searchField}
									onChange={handleSearch}
									style={{ width: '100%' }}
								/>
								<span className="searchIcon">
									<FaSearch />
								</span>
							</div>
						</form>
					</div>
					{!isMobile ? (
						<div style={{ margin: '0 15px' }}>
							<div className="row">
								{activeComponent === 'order' ? (
									<>
										<div className="col-2">Sales Order</div>
										<div className="col-4">Receiver</div>
										<div className="col-4">Product</div>
										<div className="col-2">Quantity</div>
									</>
								) : (
									<>
										<div className="col-5">Product</div>
										<div className="col-2">Quantity</div>
										<div className="col-2">Sales Order</div>
										<div className="col-3">Receiver</div>
									</>
								)}
							</div>
							<hr />
							<Scroller extraHeight={100}>
								{isLoading ? (
									[...Array(25)].map((e, i) => (
										<>
											<div className="row">
												{activeComponent === 'order' ? (
													<>
														<div className="col-2">
															<Skeleton variant="rounded" width={'100%'} height={20} />
														</div>
														<div className="col-4">
															<Skeleton variant="rounded" width={'100%'} height={20} />
														</div>
														<div className="col-4">
															<Skeleton variant="rounded" width={'100%'} height={20} />
														</div>
														<div className="col-2">
															<Skeleton variant="rounded" width={'100%'} height={20} />
														</div>
													</>
												) : (
													<>
														<div className="col-5">
															<Skeleton variant="rounded" width={'100%'} height={20} />
														</div>
														<div className="col-2">
															<Skeleton variant="rounded" width={'100%'} height={20} />
														</div>
														<div className="col-2">
															<Skeleton variant="rounded" width={'100%'} height={20} />
														</div>
														<div className="col-3">
															<Skeleton variant="rounded" width={'100%'} height={20} />
														</div>
													</>
												)}
											</div>
											<hr style={{ margin: '8px 0px 13px 0px' }} />
										</>
									))
								) : (
									data?.length > 0 ? (
										data?.map((item, index) => (
											<>
												<div className="row">
													{activeComponent === 'order' ? (
														<>
															<div className="col-2">
																<Link to={`/sales/sales-orders/${item.id}`} className="Order-number">
																	{item?.sales_order_number}
																</Link>
															</div>
															<div className="col-4">
																<Link to={`/contacts/${item.receiver_id}`} className="Order-name">
																	<PrivacyModeContent>{item?.receiver}</PrivacyModeContent>
																</Link>
															</div>
															<div className="col-4" style={{ marginTop: '-7px' }}>
																{item?.products?.length > 0 && (
																	item?.products?.map((product, index) => (
																		<div style={{ padding: '5px 0' }}>
																			<div className=" d-flex justify-left items-center">
																				<Link to={`/products/${product.product_id}`} className="Order-number">
																					{product?.product_name} {product?.color_name}
																				</Link>
																			</div>
																		</div>
																	))
																)}
															</div>
															<div className="col-2" style={{ marginTop: '-7px' }}>
																{item?.products?.length > 0 && (
																	item?.products?.map((product, index) => (
																		<div style={{ padding: '5px 0' }}>
																			<div className=" d-flex justify-left items-center textGray">
																				{product?.quantity > 1
																					? `${parseFloat(product?.quantity).toLocaleString()} pcs`
																					: `${parseFloat(product?.quantity).toLocaleString()} pc`}
																			</div>
																		</div>
																	))
																)}
															</div>
														</>
													) : (
														<>
															<div className="col-5">
																<Link to={`/products/${item.product_id}`} className="Order-number">
																	{item.product_name} {item?.color_name}
																</Link>
															</div>
															<div className="col-2 textGray">
																{item?.quantity > 1
																	? `${parseInt(item?.quantity).toLocaleString()} pcs`
																	: `${parseInt(item?.quantity).toLocaleString()} pc`}
															</div>
															<div className="col-2" style={{ marginTop: '-7px' }}>
																{item?.sales_orders?.length > 0 && (
																	item?.sales_orders?.map((sales_order, index) => (
																		<div style={{ padding: '5px 0' }}>
																			<div className=" d-flex justify-left items-center">
																				<Link to={`/sales/sales-orders/${sales_order.id}`} className="Order-number">
																					{sales_order?.sales_order_number}
																				</Link>
																			</div>
																		</div>
																	))
																)}
															</div>
															<div className="col-3" style={{ marginTop: '-7px' }}>
																{item?.sales_orders?.length > 0 && (
																	item?.sales_orders?.map((sales_order, index) => (
																		<div style={{ padding: '5px 0' }}>
																			<div className=" d-flex justify-left items-center">
																				<Link to={`/contacts/${sales_order.receiver_id}`} className="Order-number">
																					{sales_order?.receiver}
																				</Link>
																			</div>
																		</div>
																	))
																)}
															</div>
														</>
													)}
												</div>
												<hr style={{ margin: '8px 0px 13px 0px' }} />
											</>
										))
									) : (
										<div className="row">
											<div className="col-12">
												<div className="not-found-container">
													<div className="not-found-icon">
														<img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
													</div>
													<h6 className="not-found-text">No Data Available</h6>
												</div>
											</div>
										</div>
									)
								)}
							</Scroller>
						</div>
					) : (
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							{isLoading
								? // Mobile skeleton: 15 cards, each with 3 skeleton rows
								  [...Array(15)].map((_, idx) => (
										<div
											key={idx}
											style={{
												display: 'flex',
												flexDirection: 'column',
												borderBottom: '1px solid #e0e0e0',
												background: idx % 2 === 0 ? '#fff' : '#f9f9f9',
												padding: '10px 20px',
												marginBottom: 0,
												borderRadius: 0,
												gap: 8
											}}
										>
											{[...Array(3)].map((__, i) => (
												<div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%', marginBottom: 6 }}>
													<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
												</div>
											))}
										</div>
								  ))
								: data?.map((item, index) => (
										<div
											key={index}
											style={{
												display: 'flex',
												padding: '10px 20px',
												flexDirection: 'column',
												borderBottom: '1px solid #e0e0e0',
												background: index % 2 === 0 ? '#fff' : '#f9f9f9'
											}}
										>
											{activeComponent === 'order' ? (
												<>
													<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
														<div style={{ fontWeight: 500 }}>
															Sales Order:{' '}
															<Link to={`/sales/sales-orders/${item.id}`} className="Order-number">
																{item?.sales_order_number}
															</Link>
														</div>
													</div>
													<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
														<div style={{ fontWeight: 400 }}>
															Receiver:{' '}
															<Link to={`/contacts/${item.receiver_id}`} className="Order-number">
																{item?.receiver}
															</Link>
														</div>
													</div>
													{item?.products?.length > 0 && (
														<div style={{ display: 'flex', flexDirection: 'column' }}>
															{item?.products?.map((product, index) => (
																<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
																	<div style={{ fontWeight: 400 }}>
																		<Link to={`/products/${product.product_id}`} className="Order-number">
																			{product?.product_name} {product?.color_name}
																		</Link>
																	</div>
																	<div style={{ fontWeight: 400 }}>
																		<span key={index} style={{ marginLeft: 5 }}>
																			{product?.quantity > 1
																				? `${parseFloat(product?.quantity).toLocaleString()} pcs`
																				: `${parseFloat(product?.quantity).toLocaleString()} pc`}
																		</span>
																	</div>
																</div>
															))}
														</div>
													)}
												</>
											) : (
												<>
													<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
														<div style={{ fontWeight: 400 }}>
															Product:
															<Link to={`/products/${item.product_id}`} className="Order-number">
																{item.product_name} { item?.color_name}
															</Link>
														</div>
													</div>
													{item?.sales_orders?.length > 0 && (
														<div style={{ display: 'flex', flexDirection: 'column' }}>
															{item?.sales_orders?.map((order, index) => (
																<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
																	<div style={{ fontWeight: 400 }}>
																		<Link to={`/sales/sales-orders/${order.id}`} className="Order-number">
																			{order?.sales_order_number}
																		</Link>
																	</div>
																	<Link to={`/contacts/${order.receiver_id}`} className="Order-number">
																		{order?.receiver}
																	</Link>
																</div>
															))}
														</div>
													)}
												</>
											)}
										</div>
								  ))}
						</div>
					)}
					<Pagination pagination={pagination} data={handleData} onLoading={(e) => {}} />
				</div>
			</div>
		</div>
	);
};

export default Backorders;
